<template>
  <div class="news">
    <HeaderNav :current="current" :titleMsg='titleMsg'></HeaderNav>
    <div class="news-content w1200" v-loading="loading" element-loading-text="加载中"  >

      <ul class="photos-list">
        <li class="list-item" v-for="(item,index) in photosList" :key="index" @click="enterDetaisl(item)">
          <el-card :body-style="{ padding: '10px' }">
            <el-image :src="item.conver" fit='contain'></el-image>
            <!-- <img :src="item.conver" alt=""> -->
            <p>{{item.title}}</p>
          </el-card>
        </li>
      </ul>
    </div>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import { websitePageNews } from '@/api/association'
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import {formatDate} from '@/components/common/config/formatTime.js'
export default {
  name: 'tabs',
  components: {
    HeaderNav,
    CopyRight
  },
  data () {
    return {
      current: 5,
      titleMsg: '焦点',
      loading: false,
      photosList: [],
      pageNum: 1,
      pageSize: 9,
      total: null,
      canLoadMore: true,
      currentPage: 1
    }
  },
  methods: {
    formatDate,
    websitePageNews () {
      let that = this
      that.loading = true
      console.log(that.loading)
      websitePageNews({ pageNo: that.currentPage, pageSize: that.pageSize, assoId: localStorage.getItem('assoId'), type: 4 }).then(res => {
        that.loading = false

        if (res.data.status === 0) {
          if (res.data.data.list.length > 0) {
            res.data.data.list.forEach((value) => {
              that.photosList.push(value)
            })
            that.total = res.data.data.total
          }
          if (res.data.data.list === null || res.data.data.list.length < that.pageSize) {
            that.canLoadMore = false
          }
        }
      }).catch((res) => {
        that.loading = false
        // hideLoading()
        that.$message.warning('网络错误')
      })
      // that.loading = true
    },
    handleCurrentChange: function (val) {
      this.websitePageNews()
    },
    // 下拉加载更多数据添加方法
    handleScroll: function () {
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight // 窗口的高度
      var scrollTop = Math.abs(document.documentElement.scrollTop)// 顶部距离窗口的高度
      var result = document.body.scrollHeight// body的高度
      var scrollFooter = 200// 网页底部的高
      // debugger
      if ((scrollTop + clientHeight + scrollFooter) > (result) && this.canLoadMore) {
        this.currentPage += 1
        this.websitePageNews()
      }
    },
    enterDetaisl (item) {
      this.$router.push({
        path: `FocusDetails`,
        query: { newsId: item.id }
      })
    }
  },
  mounted () {
    // 下拉加载更多监听滚轮
    window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮 滚动事件
  },
  created () {
    this.websitePageNews()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .news {
    width: 100%;
    background-color: #fff;
  }

  .news-content {
    width: 1100px;
    padding: 20px ;
    background: #f3f3f3;
    border-radius: 10px;
    margin-top: 20px;
    margin-bottom:20px;
    min-height: 600px;
  }
  .text {
    border-radius: 5px;
    background: #fff;
    margin-top: 30px;
    padding: 20px 10px;
    border-bottom: 1px solid #f6f6f6;
  }
  .text p {
    font-size: 14px;
    color:#888;
    padding: 15px;
  }
  .photos-list{
    width: 1000px;
    margin: 0px auto;
    overflow: hidden;
  }
  .photos-list .list-item{
    width: 333px;
    float: left;
    padding: 10px;
    box-sizing: border-box;
    /* margin-right: 10px; */
  }
  .photos-list .list-item:hover{
    transform: scale(1.02)
  }
  .photos-list .list-item:nth-child(3n){
    margin-right: 0px;
  }
  .photos-list .list-item img{
    /* width: 236px; */
    /* height: 236px; */
    display: block;
    margin: 0px auto;
  }
  .photos-list .list-item p{
    font-size: 14px;
    color:#282828;
    line-height: 18px;
    margin-top: 16px;
    min-block-size: 36px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>



// WEBPACK FOOTER //
// src/components/Focus/FocussList.vue